// @flow
export function metresToMiles(metres: number): string {
  return (metres * 0.000621371192).toFixed(2);
}
